import { createSlice } from "@reduxjs/toolkit";
import type { Asset } from "~/types";

export type AdminInitialStateType = {
	ifoDetails: Partial<Asset['ifoDetails']> | null,
}

export const adminInitialState: AdminInitialStateType = {
	ifoDetails: null,
};

const adminSlice = createSlice({
	name: "admin",
	initialState: adminInitialState,
	reducers: {
		adminPropertyIFODetailsChangeAction: (state, { payload }: { type: string, payload: Partial<Asset['ifoDetails']> | null }) => {
			state.ifoDetails = payload;
		}
	},
});

export const { adminPropertyIFODetailsChangeAction } = adminSlice.actions;

export const adminReducer = adminSlice.reducer;
